import type { LooseAutocomplete } from "@jti/commerce/shared";
import type { Product } from "@jti/magento";
import { FormattedPrice } from "@jti/ui";

import { QTY_MULTIPLY_SYMBOL } from "../../const";
import { getBundleQuantityCount, getQuantityText } from "../../utils";
import { BundleOptionRows } from "../BundleOptionRow";

import styles from "./SubscriptonProductCard.module.scss";

export type ProductType = LooseAutocomplete<"bundle"> | undefined;

const NUMBER_OF_STICKS_IN_PACK = 20;

export const SubscriptionProductCard = ({
  name,
  imageUrl,
  price,
  quantity,
  bundle_options = [],
  product_type = "bundle",
}: Product) => {
  const numberOfPacks = getBundleQuantityCount(bundle_options, product_type);
  const subtitle = getQuantityText(quantity, numberOfPacks, NUMBER_OF_STICKS_IN_PACK);

  return (
    <div className={styles.card} data-testid="subscription-product-card">
      <div className={styles.wrapper}>
        <div className={styles.mainProduct}>
          <div className={styles.imageContainer}>
            {imageUrl && <img src={imageUrl} className={styles.image} alt={name} />}
          </div>

          <div>
            <div className={styles.title}>{`${quantity}${QTY_MULTIPLY_SYMBOL} ${name}`}</div>
            <div className={styles.subtitle} dir="ltr">
              {subtitle}
            </div>
            <FormattedPrice className={styles.price} value={price.value} currency={price.currency} />
          </div>
        </div>

        <ul className={styles.optionsWrapper}>
          {bundle_options?.map(
            ({ id: bundleId, values }) =>
              !!values?.length && (
                <li key={bundleId}>
                  <BundleOptionRows values={values} />
                </li>
              )
          )}
        </ul>
      </div>
    </div>
  );
};
